import { Navigate, Outlet } from 'react-router-dom';
import { useIsOnboarded } from '../hooks/use-is-onboarded';
import { UserProvider } from '../providers/UserProvider';

function OnboardGuard(): JSX.Element {
    const { isLoading, isOnboarded } = useIsOnboarded();

    if (isLoading) {
        return <p>Loading...</p>;
    }
    if (!isOnboarded) {
        return <Navigate to="/onboarding" />;
    }

    return (
        <UserProvider>
            <Outlet />
        </UserProvider>
    );
}

export default OnboardGuard;
